import React, { ButtonHTMLAttributes } from "react";
import classNames from "classnames";
import { ButtonContainer, IcOptions32 } from "../../index";

import "../../../../sass/ui-library/components/simple/ButtonOptions.scss";

export const ButtonOptions = ({ className, ...rest }: ButtonHTMLAttributes<HTMLButtonElement>) => (
    <ButtonContainer icon={<IcOptions32 />} className={classNames(className, "btn-options")} {...rest} />
);
